import AppExtensionsSDK, {
	Command,
	Event,
	Modal,
	ModalStatus,
	Color,
	TrackingEvent,
	MessageType,
	View,
	VisibilityEventInvoker,
} from './index';

export default Object.assign(AppExtensionsSDK, {
	Command,
	Event,
	Modal,
	ModalStatus,
	Color,
	TrackingEvent,
	MessageType,
	View,
	VisibilityEventInvoker,
});
